<template>
  <div>
    <joy-page :joyPageStatus="joyPageStatus">
      <van-pull-refresh
        v-model="isLoading"
        @refresh="onRefresh"
      >
        <template v-if="list.length==0">
          <noneData></noneData>
        </template>
        <template v-else>
          <van-list
            v-model="loading"
            :finished="finished"
            finished-text="加载完毕"
            @load="onLoad"
          >
            <div class="paddingbottom50">
              <div
                class="marginBottomXm"
                v-for="(item, index) in list"
                :key="index"
              >
                <div class="text-xl text-bold text-black paddingXm">{{ item.party_title }}</div>
                <van-cell
                  title="营期"
                  :value="item.title"
                />
                <van-cell title="职级">
                  <span slot="default">
                    <span v-if="item.type == 1">大队长</span>
                    <span v-if="item.type == 2">中队长</span>
                    <span v-if="item.type == 3">小队长</span>
                  </span>
                </van-cell>
                <van-cell>
                  <van-button
                    slot="default"
                    type="primary"
                    size="mini"
                    @click="showPicker(item)"
                  >查看</van-button>
                </van-cell>
              </div>
            </div>
          </van-list>
        </template>
      </van-pull-refresh>
    </joy-page>
    <!-- 底部tab -->
    <myFoot></myFoot>
    <!-- 返回顶部 -->
    <backTop ref="bt"></backTop>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
export default {
  components: {},
  created(e) {
    this.onLoad()
    this.wxShare()
  },
  computed: {
    ...mapState(['token', 'site']),
    ...mapGetters(['hasLogin']),
  },
  data() {
    return {
      joyPageStatus: '',
      list: [],
      loading: false,
      finished: false,
      isLoading: false,
    }
  },
  methods: {
    showPicker(item) {
      // console.log(item.type)
      this.camp_id = item.id
      if (item.type == 3) {
        this.$router.push({
          path: '/subPackages/myTask/taskDetail',
          query: {
            camp_id: item.id,
            user_id: item.user_id,
            type: item.type,
          },
        })
        return
      } else {
        this.$router.push({
          path: '/subPackages/myTask/taskRelationship',
          query: {
            camp_id: item.id,
            user_id: item.user_id,
            type: item.type,
          },
        })
      }
    },
    onRefresh() {
      setTimeout(() => {
        this.$toast('刷新成功')
        this.isLoading = false
        this.reload()
      }, 500)
    },
    onLoad() {
      // 异步更新数据
      setTimeout(() => {
        this.loadData()
      }, 500)
    },
    reload() {
      this.list = []
      this.loading = false
      this.finished = false
      this.onLoad()
    },
    loadData() {
      let id = this.$route.query.id
      const that = this
      this.joyPageStatus = 'loading'
      try {
        this.$axios.get('party/list').then((res) => {
          if (res.data.code == 200) {
            this.joyPageStatus = 'success'
            this.list = res.data.data
            this.loading = false
            this.finished = true
          }
        })
      } catch (e) {
        if (this.$mConfig.debug) {
          console.log(e)
        }
      }
    },
  },
}
</script>

<style scoped="scoped">
@import url('../../colorui/main.css');
</style>
